import { createSlice } from "@reduxjs/toolkit";
import Resizer from "react-image-file-resizer";
import { startCamera, clearCurrentCameraTrack } from "slices/devicesSlice";
import {
  MAX_AVATAR_SIDE_LENGTH,
  MIN_AVATAR_SIDE_LENGTH,
  MAX_AVATAR_SIZE,
} from "constants/constants";
import axiosUpload from "helpers/axios/axiosUpload";
import axiosGeneral from "helpers/axios/axiosGeneral";
import {
  userPool,
  setCurrentUserAttributes,
  getCurrentToken,
  selectCurrentUserAttributes,
} from "slices/authSlice";
let dispatch = null;
let getState = null;
import("Store").then((module) => {
  dispatch = module.store.dispatch;
  getState = module.store.getState;
});

let confirmPicAction = null;
export function getConfirmPicAction() {
  return confirmPicAction;
}
export function setConfirmPicAction(action) {
  confirmPicAction = action;
}
export function resetConfirmPicAction() {
  confirmPicAction = null;
}
export function doConfirmPicAction() {
  if (confirmPicAction) confirmPicAction();
}

export const slice = createSlice({
  name: "createPicture",
  initialState: {
    settingPicture: false,
    changePicError: null,
    previewType: null,
    picToUpload: null,
    fileChosen: null,
    photoContextDims: null,
  },
  reducers: {
    setSettingPicture: (state, action) => {
      state.settingPicture = action.payload;
    },
    setChangePicError: (state, action) => {
      state.changePicError = action.payload;
    },
    setPreviewType: (state, action) => {
      state.previewType = action.payload;
    },
    setPicToUpload: (state, action) => {
      state.picToUpload = action.payload;
    },
    setFileChosen: (state, action) => {
      state.fileChosen = action.payload;
    },
    setPhotoContextDims: (state, action) => {
      state.photoContextDims = action.payload;
    },
    resetCreatePicture: (state) => {
      state.settingPicture = false;
      state.changePicError = null;
      state.previewType = null;
      state.picToUpload = null;
      state.fileChosen = null;
      state.photoContextDims = null;
    },
  },
});

const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      MAX_AVATAR_SIDE_LENGTH,
      MAX_AVATAR_SIDE_LENGTH,
      "JPEG",
      80,
      0,
      (uri) => {
        resolve(uri);
      },
      "blob",
      MIN_AVATAR_SIDE_LENGTH,
      MIN_AVATAR_SIDE_LENGTH
    );
  });

export const getPicType = () => async (dispatch, getState) => {
  var previewType = null;
  if (selectCurrentUserAttributes(getState()).avatar_key) {
    previewType = PT_EXISTING;
  } else {
    previewType = PT_NONE;
  }
  dispatch(setPreviewType(previewType));
};

export const setPictureFile = (file) => async (dispatch) => {
  dispatch(setChangePicError(null));
  //Perform validation (just checking size < 3MB)
  if (file.size > MAX_AVATAR_SIZE) {
    dispatch(setChangePicError("Image must be less than 6MB"));
    return;
  }
  try {
    const picture = await resizeFile(file);
    window.efs_debug && window.log("Pic to set");
    window.efs_debug && window.log(picture);
    dispatch(setPicToUpload(picture));
    dispatch(setFileChosen(file.name));
    dispatch(setPreviewType(PT_FILE));
  } catch (err) {
    window.efs_debug && window.log("Pic to set" + JSON.stringify(err));
    dispatch(setChangePicError("Image not compatible"));
  }
};

export const deletePicture = () => async (dispatch) => {
  clearCurrentCameraTrack();
  dispatch(setPicToUpload(null));
  dispatch(setFileChosen(null));
  dispatch(setPreviewType(PT_NONE));
  dispatch(setSettingPicture(false));
  dispatch(setPhotoContextDims(null));
  dispatch(setChangePicError(null));
};

export const confirmPicture = () =>
  new Promise((res, rej) => {
    dispatch(setChangePicError(null));
    dispatch(setSettingPicture(true));

    userPool.getCurrentUser().getSession((err, sesh) => {
      if (err) {
        alert(err.message || JSON.stringify(err));
        window.efs_debug && window.log("Session not valid: " + sesh.isValid());
        rej();
        return;
      }
      getCurrentToken().then((idToken) => {
        const file = getState().createPicture.picToUpload;
        if (file == null) {
          axiosGeneral
            .delete(`/me/avatar`, {
              headers: {
                Authorization: "Bearer " + idToken,
              },
            })
            .then((response) => {
              ////upload, server check and wait/////
              window.efs_debug &&
                window.log("confirmed profile picture delete" + response);
              window.efs_debug && window.log(response);
              let current = selectCurrentUserAttributes(getState());
              dispatch(
                setCurrentUserAttributes({
                  ...current,
                  avatar_key: null,
                })
              );
              res();
            })
            .catch((error) => {
              window.efs_debug &&
                window.log("error deleting profile pic" + error);
              window.efs_debug && window.log(error);

              //else
              dispatch(setSettingPicture(false));
              dispatch(setChangePicError("Error Deleting Avatar"));
              dispatch(setPreviewType(PT_NONE));
              dispatch(setPicToUpload(null));
              dispatch(setFileChosen(null));
              rej();
            });
        } else {
          const data = new FormData();
          data.append("file", file);

          axiosUpload
            .post(`/me/avatar`, data, {
              headers: {
                Authorization: "Bearer " + idToken,
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              ////upload, server check and wait/////
              window.efs_debug &&
                window.log("confirmed profile picture upload" + response);
              let current = selectCurrentUserAttributes(getState());
              dispatch(
                setCurrentUserAttributes({
                  ...current,
                  avatar_key: response.data.user.avatar_key,
                })
              );
              //////////////////////////////////////
              res();
            })
            .catch((error) => {
              window.efs_debug &&
                window.log("error uploading profile pic" + error);
              window.efs_debug && window.log(error);

              //else
              dispatch(setSettingPicture(false));
              dispatch(setChangePicError("Error Uploading Avatar"));
              dispatch(setPreviewType(PT_NONE));
              dispatch(setPicToUpload(null));
              dispatch(setFileChosen(null));
              rej();
            });
        }
      });
    });
  });

export const beginUseCamera = () => async (dispatch) => {
  dispatch(setSettingPicture(true));
  dispatch(setPreviewType(PT_USE_CAMERA));
  startCamera({ height: { ideal: MAX_AVATAR_SIDE_LENGTH } });
};

export const stopUseCamera = () => async (dispatch) => {
  clearCurrentCameraTrack();
  dispatch(getPicType());
  dispatch(setSettingPicture(false));
  dispatch(setPhotoContextDims(null));
};

export const takeMyPic = () => async (dispatch, getState) => {
  var canvasRef = document.getElementById("createPictureCanvasElement");
  var videoRef = document.getElementById("createPictureVideoElement");
  if (!canvasRef) {
    dispatch(stopUseCamera());
    window.efs_debug && window.log("Error: there is no canvasRef");
  }
  if (!getState().createPicture.photoContextDims) {
    return;
  }

  //Taking the centre of the video feed element and getting a MAX_AVATAR_SIDE_LENGTHxMAX_AVATAR_SIDE_LENGTH picture from it.
  //Also checking if the video feed element is at least MAX_AVATAR_SIDE_LENGTHxMAX_AVATAR_SIDE_LENGTH
  var videoWidth = getState().createPicture.photoContextDims.width;
  var videoHeight = getState().createPicture.photoContextDims.height;
  var cX = Math.floor(videoWidth / 2);
  var cY = Math.floor(videoHeight / 2);
  var wide = videoWidth > videoHeight;
  var iX = 0;
  var iY = 0;
  var wX = 0;
  var wY = 0;
  if (wide) {
    iX = cX - cY;
    iY = 0;
    wX = videoHeight;
    wY = videoHeight;
  } else {
    iY = cY - cX;
    iX = 0;
    wX = videoWidth;
    wY = videoWidth;
  }

  window.efs_debug && window.log(cX, cY, iX, iY, wX, wY);
  let ctx = canvasRef.getContext("2d");
  // ctx.transform(-1, 0, 0, 1, MAX_AVATAR_SIDE_LENGTH, 0);
  ctx.drawImage(
    videoRef,
    //initial X & Y's    and    final X & Y's
    iX,
    iY,
    wX,
    wY,
    0,
    0,
    MAX_AVATAR_SIDE_LENGTH,
    MAX_AVATAR_SIDE_LENGTH
  );
  clearCurrentCameraTrack();
  canvasRef.toBlob((profilePic) => {
    dispatch(setPicToUpload(profilePic));
    dispatch(setSettingPicture(false));
    dispatch(setPhotoContextDims(null));
    dispatch(setPreviewType(PT_SNAPPED_PICTURE));
  }, "image/jpeg");
};

export const PT_FILE = "PT_FILE";
export const PT_USE_CAMERA = "PT_USE_CAMERA";
export const PT_SNAPPED_PICTURE = "PT_SNAPPED_PICTURE";
export const PT_EXISTING = "PT_EXISTING";
export const PT_NONE = "PT_NONE";

export const {
  setSettingPicture,
  setChangePicError,
  setPreviewType,
  setPicToUpload,
  setFileChosen,
  setPhotoContextDims,
  resetCreatePicture,
} = slice.actions;

export const selectSettingPicture = (state) =>
  state.createPicture.settingPicture;
export const selectChangePicError = (state) =>
  state.createPicture.changePicError;
export const selectPreviewType = (state) => state.createPicture.previewType;
export const selectPicToUpload = (state) => state.createPicture.picToUpload;
export const selectFileChosen = (state) => state.createPicture.fileChosen;
export const selectPhotoContextDims = (state) =>
  state.createPicture.photoContextDims;

export default slice.reducer;
